import CheckIcon from '@mui/icons-material/Check'
import Button from '@mui/material/Button'
import { useCiboAutoForm } from './CiboAutoFormContext'

export interface SubmitFieldProps {
  value?: string
  label?: string
  disabled?: boolean
  [key: string]: unknown
}

export function SubmitField({ disabled: disabledProp, ...rest }: SubmitFieldProps) {
  const { disabled, errors, hasExistingModel, isDirty, submitting } = useCiboAutoForm()

  const hasErrors = errors.length > 0
  const shouldShowUpdate = Boolean(hasExistingModel && isDirty)
  // Explicit disabled={false} signals the caller knows the form should be submittable
  // even when the local model hasn't changed (e.g. multi-field editing where other
  // fields differ from the current value).
  const forceEnabled = disabledProp === false
  const shouldShowSaved = forceEnabled ? false : Boolean(hasExistingModel && !shouldShowUpdate)
  const buttonText = hasExistingModel ? (shouldShowUpdate || forceEnabled ? 'Update' : 'Saved') : 'Save'

  return (
    <Button
      type="submit"
      variant="contained"
      loading={submitting}
      disabled={Boolean((!forceEnabled && disabledProp) || disabled || submitting || hasErrors || shouldShowSaved)}
      endIcon={shouldShowSaved ? <CheckIcon /> : undefined}
      {...rest}
    >
      {buttonText}
    </Button>
  )
}
